import BuscaSimplesCards from '@/components/BuscaSimplesCards.vue';

export const mixinAtoInfralegal = {
  components: {
    BuscaSimplesCards,
  },
  data() {
    return {
      cardsAtoInfralegal: [
        {
          rota: 'PorTipoAtoInfralegal',
          icone: require('@/assets/images/icon-tipo-legislacao2.png'),
          iconeClasse: 'legisla-icon',
          titulo: 'Tipo de Ato Infralegal',
          descricao: 'Consulte o Ato Infralegal<br /> por <strong>tipo</strong>',
        },
        {
          rota: 'PorOrgaoAtoInfralegal',
          icone: require('@/assets/images/orgao-atos-icon-min2.png'),
          iconeClasse: 'orgao-icon',
          titulo: 'Órgão',
          descricao: 'Consulte o Ato Infralegal<br /> por <strong>órgão</strong>',
        },
        {
          rota: 'PorAnoAtoInfralegal',
          icone: require('@/assets/images/icon-indice-cronologico2.png'),
          iconeClasse: 'indice-icon',
          titulo: 'Índice Cronológico',
          descricao: 'Consulte o Ato Infralegal<br /> por <strong>ano</strong>',
        },
      ],
    };
  },
};